import React from 'react';

import isArchived from 'archive/isArchived';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {UserSummary} from 'constants/UserConstants';
import SidepanelItem from 'nav/sidepanel/listing/SidepanelItem';
import {ListableItem} from 'search/SearchConstants';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import fuzzydate from 'util/fuzzydate';

import {RequestV2SubmissionListingGraphQL} from '../../../../graphql-fragments/processes/requests-v2/__generated/RequestV2SubmissionListingGraphQL';

export interface RequestV2SubmissionSidepanelItemProps {
  isActive: boolean;
  isCompact: boolean;
  openResult: (item: ListableItem) => void;
  requestV2Submission: RequestV2SubmissionListingGraphQL;
  isChild: boolean;
}

export default function RequestV2SubmissionSidepanelItem(
  props: RequestV2SubmissionSidepanelItemProps
): JSX.Element {
  const {isActive, isCompact, requestV2Submission, isChild} = props;
  const date = fuzzydate(requestV2Submission.createdAt, {compact: isCompact, showTime: false});
  const subtitle = `${isCompact ? '' : 'Created '}${date}`;
  const creator: UserSummary = {
    ...requestV2Submission.creator,
    avatar_url: requestV2Submission.creator.avatar_url!,
  };
  return (
    <SidepanelItem
      active={isActive}
      className="sidepanelItem--noIcon"
      faded={isArchived(requestV2Submission)}
      icon={<BenchlingIcon icon={ModelTypeConstants.REQUEST_V2_SUBMISSION} />}
      isCompact={isCompact}
      onClick={() => {
        props.openResult(requestV2Submission);
      }}
      subTitle={subtitle}
      title={{
        text: requestV2Submission.name,
        node: <div>{requestV2Submission.name}</div>,
      }}
      parties={[creator]}
      tooltipText=""
      onContextMenu={(e: React.SyntheticEvent) => {}}
      isExpandable={false}
      isChild={isChild}
    />
  );
}
